export default __webpack_public_path__ + "static/media/kathy.8bb88246.png";